export default __webpack_public_path__ + "static/media/Croc.79a80011.png";